import { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Interceptor from "@api/Interceptor/Interceptor";
import Header from '@components/header'
import Footer from '@components/footer'
import pages from "@pages";


const App = () => {

  const location = useLocation()
  const [pathname, setPathname] = useState(location.pathname);

  const { Home, Login, HotelListing, HotelsInLucknow, HotelDetails, Bookhotel, BookingConfirm, UserProfile, TAProfile, PropertyInquery, PageNotFound, CreateTABooking, About, Career, UserAgreement, HowItWorks, HelpCenter, PrivacyPolicy, TermsAndConditions, CancellationRefundPolicy, PartnershipPrograms, PromotionEvents, Contact, Community } = pages;

  useEffect(() => {
    setPathname(location.pathname)
  }, [location])

  return (
    <>
      <Interceptor />
      {
        pathname != "/login" && <Header />
      }
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/login" element={<Login />} />
        <Route path="/hotel-listing" element={<HotelListing />} />
        <Route path="/hotels-in-lucknow" element={<HotelsInLucknow />} />
        <Route path="/hotel-details/*" element={<HotelDetails />} />
        <Route path="/hotels-in-lucknow/*" element={<HotelDetails />} />
        <Route path="/book-hotel/:hotelId" element={<Bookhotel />} />
        <Route path="/booking-confirm/:id" element={<BookingConfirm />} />
        <Route path="/user-profile" element={<UserProfile />} />
        <Route path="/ta-profile" element={<TAProfile />} />
        <Route path="/create-booking" element={<CreateTABooking />} />
        <Route path="/property-enquiry" element={<PropertyInquery />} />



        <Route path="/about-us" element={<About />} />
        <Route path="/career" element={<Career />} />
        <Route path="/user-agreement" element={<UserAgreement />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/help-center" element={<HelpCenter />} />
        <Route path="/Rrooms-privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/cancellation-refund-policy" element={<CancellationRefundPolicy />} />
        <Route path="/Partnership-program" element={<PartnershipPrograms />} />
        <Route path="/Promotion-events" element={<PromotionEvents />} />
        <Route path="/Community" element={<Community />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/*" element={<PageNotFound />} />
      </Routes>
      {
        pathname != "/login" && <Footer />
      }
    </>
  );
}

export default App;
